<template>
  <div class="page">
    <PageHeader :links="headLinks" />

    <div class="pageMain">
      <div class="topbar m-b-25 d-flex flex-j-between">
        <div class="searchBox">
          <div style="float: left">
            <el-select v-model="f_type" placeholder="请选择缴费情况" width="80">
              <el-option label="不限缴费情况" :value="0">不限缴费情况</el-option>
              <el-option label="未缴纳出版费" :value="1">未缴纳出版费</el-option>
              <el-option label="已缴纳出版费" :value="2">已缴纳出版费</el-option>
            </el-select>
          </div>
          <div style="float: left; width: 300px">
            <el-input placeholder="稿件标题" v-model="f_title" class="input-with-select">
              <el-button slot="append" icon="el-icon-search" @click="loadData">搜索</el-button>
            </el-input>
          </div>
        </div>
      </div>

      <el-row>
        <el-col :span="24">
          <el-table ref="tableData" :data="tableData" stripe @select-all="selAll" @selection-change="selChange" border style="width: 100%">
            <el-table-column type="index" label="序号" width="60" align="center"> </el-table-column>
            <el-table-column prop="sn" label="稿件编号" width="100">
              <template slot-scope="scope">
                <span class="sn">{{ scope.row.sn }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="稿件标题" min-width="200">
              <template slot-scope="scope">
                <h3>{{ scope.row.title }}</h3>
              </template>
            </el-table-column>

            <el-table-column prop="subjectName" :label="subName" width="90"></el-table-column>
            <el-table-column prop="authorName" label="作者" width="80"></el-table-column>

            <el-table-column prop="createTime" label="投稿时间" width="140">
              <template slot-scope="scope">
                {{ scope.row.createTime | datefmt2("YYYY-MM-DD HH:mm:ss") }}
              </template>
            </el-table-column>

            <el-table-column prop="issueCost" label="应收出版费" width="90">
              <template slot-scope="scope"> ￥{{ scope.row.issueCost }} </template>
            </el-table-column>
            <el-table-column prop="issueCosted" label="实缴出版费" width="90">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.issueCosted == null || scope.row.issueCosted == -1" type="danger">尚未缴纳</el-tag>
                <span v-else>{{ scope.row.issueCosted }}</span>
              </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作" align="center" width="110">
              <template slot-scope="scope">
                <el-button v-if="scope.row.issueCosted != null && scope.row.issueCosted != -1" size="small" type="primary" @click="showProcess(scope.row.id)">缴费详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <div style="margin: 20px 0 0 -5px">
        <el-pagination background layout="sizes,prev, pager, next" :total="total" :page-size="pageSize" :page-sizes="[15, 30, 50, 100]" :current-page="curPage" @current-change="pageChange" @size-change="pageSizeChange"> </el-pagination>
      </div>
    </div>

    <el-drawer title="批量登记出版费" :visible.sync="drawer" :direction="'rtl'" :size="700" :destroy-on-close="true" :wrapperClosable="false">
      <div class="flex-1 d-flex flex-column">
        <div class="flex-1" style="padding: 0 20px 20px 20px">
          <el-form rel="ruelForm" :model="form">
            <el-form-item prop="employNotice" label="稿件及出版费记录">
              <el-table :data="selData" border style="width: 100%">
                <el-table-column prop="title" label="稿件标题"> </el-table-column>
                <el-table-column prop="bmf" label="出版费"> </el-table-column>
              </el-table>
            </el-form-item>
            <el-form-item prop="employNotice" label="拟录取通知正文">
              <el-input type="textarea" :rows="14" placeholder="拟录取通知正文" v-model="form.employNotice"> </el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-drawer>

    <!--div class="panelDj">
    234234
  </div-->
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import http from "@/api/http"
import editorApi from "@/api/editor"
import { getToken } from "@/utils/auth"
/**
 * 待评审页面
 * 步骤,100退稿。
 * 10作者提交稿件，
 * 20待编辑首次审稿，21作者一次改稿,22编辑第二次审稿。
 * 30交审稿费。
 * 40专家首次审稿，41作者二次改稿,42专家第二次审稿。
 *
 * 50编辑查重，51作者三次改稿，52编辑二次查重。
 * 60登记版面费，出录用通知；
 * 70交版面费。
 * 80填写发票信息。
 * 90完成。
 */
export default {
  components: { PageHeader },
  data() {
    return {
      subName: process.env.VUE_APP_PLATFORM == "dx" ? "栏目" : "科目",
      headLinks: [{ path: "", title: "出版费缴纳情况查询" }],
      subjects: [],
      f_type: 0,
      f_title: "",
      curPage: 1,
      pageSize: 20,
      tableData: [],
      selData: [],
      total: 0,
      drawer: false,
      flag: false,
      curArticleId: 0,
      amounts: [],
      articleIds: [],

      form: {
        employNotice: "你好，你的论文{$title}有较高的学术价值，拟安排出版在2021年8月期出版！请勿转投其他期刊",
      },
      uploadHeaders: { Authorization: getToken() },
      importTemplateFile: "",
    }
  },

  created() {
    this.uploadURL = http.defaults.baseURL + "editor/article/excelImport"
    this.importTemplateFile = http.defaults.baseURL + "download/cha.xlsx"
  },

  mounted() {
    this.loadData()
  },

  methods: {
    getRate(rate1, rate2) {
      return rate2 > rate1 ? rate2 : rate1
    },
    uploadBefore(file) {
      console.log(file.type)
      const isDOC = file.type === "application/vnd.ms-excel"
      const isDOCX = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      const isLt5M = file.size / 1024 / 1024 < 5

      if (!isDOC && !isDOCX) {
        this.$alert("XLS/XLSX 格式!", "系统提示", {
          confirmButtonText: "确定",
        })
        return false
      }
      if (!isLt5M) {
        this.$alert("上传文件不能超过 5MB!", "系统提示", {
          confirmButtonText: "确定",
        })
      }
      return (isDOC || isDOCX) && isLt5M
    },

    uploadSuccess(res) {
      if (res.code == 1) {
        this.$alert("登记导入失败,请重新上传", "异常提示", {
          confirmButtonText: "确定",
          type: "warning",
        })
      } else {
        this.$notify.success({
          title: "登记导入成功",
          message: res.msg,
        })
        this.loadData()
      }
    },

    pageChange(curPage) {
      this.curPage = curPage
      this.loadData()
    },

    pageSizeChange(val) {
      this.pageSize = val
      this.curPage = 1
      this.loadData()
    },

    loadData() {
      this.tableData = []
      editorApi.getBmfList(-1, this.f_title, this.f_type, "id", "desc", this.curPage, this.pageSize).then((res) => {
        this.tableData = res.rows
        this.total = res.total
      })
    },

    selAll() {
      this.flag = this.$refs.tableData.selection.length > 0
    },
    selChange() {
      this.flag = this.$refs.tableData.selection.length > 0
    },

    openBmf() {
      this.drawer = true

      this.selData = this.$refs.tableData.selection
      this.amounts = []
      this.articleIds = []

      this.selData.forEach((element) => {
        this.amounts.push(element.bmf)
        this.articleIds.push(element.id)
      })
    },

    submit() {
      editorApi.doCharge(this.articleIds, this.amounts, this.form.employNotice).then((res) => {
        if (res.code == 0) {
          this.drawer = false
          this.$notify.success({
            title: "错误",
            message: "登记成功！",
          })
          this.loadData()
        } else {
          this.$notify.error({
            title: "错误",
            message: res.msg,
          })
        }
      })
    },
  },
}
</script>

<style scoped>
.dengJi {
  border: 1px solid #ccc;
  margin-bottom: 25px;
}
.searchBox::after {
  content: "";
  display: block;
  clear: both;
}

.el-table /deep/ th.col-bmf {
  background-color: #409eff !important;
}
.el-table /deep/ th.col-bmf > .cell {
  color: #fff;
}

.el-table--striped /deep/ td.col-bmf {
  background-color: #409eff !important;
}

.panelDj {
  width: calc(100vw - 200px);
  height: 400px;
  border: 1px solid #eee;
  background-color: #fff;
  padding: 15px;
  position: absolute;
  z-index: 800;
  bottom: 0;
}
</style>
